import { Search as SearchIcon } from "@mui/icons-material";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  TextField,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectSpots } from "../../features/spots/spotsSlice";
import { createSpotSlug } from "../utils/utils";

const Search = () => {
  const [search, setSearch] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const spots = useSelector(selectSpots);

  const handleChange = ({ target }) => {
    const { value } = target;
    setSearch(value);
  };

  const handleSelectSpot = (spot) => {
    setSearch(spot.name);
    const slug = createSpotSlug(spot.name, spot.country, spot.id);
    navigate(`/destination/${slug}`);
    setIsFocused(false);
  };

  const suggestions = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query || !spots?.length) return [];

    return spots
      .filter(
        (spot) =>
          spot.name.toLowerCase().includes(query) ||
          spot.country.toLowerCase().includes(query)
      )
      .slice(0, 8);
  }, [search, spots]);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 999,
          px: { xs: 2, sm: 3 },
          py: 0,
          height: 64,
          bgcolor: "#f9f9f9",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          gap: 2,
        }}
      >
        <SearchIcon
          sx={{ color: "text.secondary", fontSize: 24, flexShrink: 0 }}
        />

        <TextField
          variant="filled"
          placeholder="Surf spot, village, country..."
          sx={{
            flex: 1,
            bgcolor: "transparent",
            "& .MuiFilledInput-root": {
              bgcolor: "transparent",
              px: 0,
              height: 44,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiFilledInput-input": {
              py: 0,
            },
          }}
          InputProps={{
            disableUnderline: true,
          }}
          value={search}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            // Delay closing so click events on suggestions can fire
            setTimeout(() => setIsFocused(false), 100);
          }}
        />
      </Paper>

      {isFocused && suggestions.length > 0 && (
        <Paper
          elevation={4}
          sx={{
            position: "absolute",
            top: "110%",
            left: 0,
            right: 0,
            mt: 0.5,
            maxHeight: 300,
            overflowY: "auto",
            zIndex: 10,
          }}
        >
          <List dense>
            {suggestions.map((spot) => (
              <ListItemButton
                key={spot.id}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handleSelectSpot(spot)}
              >
                <ListItemText
                  primary={spot.name}
                  secondary={spot.country}
                  primaryTypographyProps={{ noWrap: true }}
                  secondaryTypographyProps={{ noWrap: true }}
                />
              </ListItemButton>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
};

export default Search;
